import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";

function Catalogs() {
  const [catalogs, setCatalogs] = useState([]);
  const [newItem, setNewItem] = useState({ title: "", link: "" });

  const fetchCatalogs = async () => {
    const q = await getDocs(collection(db, "catalogs"));
    setCatalogs(q.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => { fetchCatalogs(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if(!newItem.title || !newItem.link) return alert("Please fill both fields");
    
    await addDoc(collection(db, "catalogs"), {
        title: newItem.title,
        link: newItem.link,
        createdAt: new Date().toISOString()
    });
    setNewItem({ title: "", link: "" });
    fetchCatalogs();
    alert("Catalog Added!");
  };

  const handleDelete = async (id) => {
    if(window.confirm("Delete this catalog?")) {
        await deleteDoc(doc(db, "catalogs", id));
        fetchCatalogs();
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2 style={{ color: "#27ae60" }}>📚 Product Catalogs (PDFs)</h2>

      {/* --- ADD FORM --- */}
      <div style={{ backgroundColor: "white", padding: "20px", borderRadius: "8px", marginBottom: "20px", boxShadow: "0 2px 5px rgba(0,0,0,0.1)" }}>
        <h3>Add New Brochure</h3>
        <p style={{fontSize:"12px", color:"gray"}}>Paste your Google Drive / Dropbox link here.</p>
        <form onSubmit={handleAdd} style={{display:"flex", gap:"10px", flexWrap:"wrap"}}>
            <input 
                type="text" placeholder="Brochure Title (e.g. Ventilator V1)" 
                value={newItem.title} onChange={(e) => setNewItem({...newItem, title:e.target.value})}
                style={inputStyle}
            />
            <input 
                type="text" placeholder="Paste PDF Link Here..." 
                value={newItem.link} onChange={(e) => setNewItem({...newItem, link:e.target.value})}
                style={{...inputStyle, flex:2}}
            />
            <button type="submit" style={btnAdd}>➕ Add Catalog</button>
        </form>
      </div>

      {/* --- LIST --- */}
      <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
        {catalogs.map(item => (
            <div key={item.id} style={{backgroundColor:"white", padding:"15px", borderRadius:"8px", display:"flex", justifyContent:"space-between", alignItems:"center", borderLeft:"5px solid #27ae60", boxShadow:"0 2px 5px rgba(0,0,0,0.05)"}}>
                <div>
                    <h4 style={{margin:0, color:"#333"}}>{item.title}</h4>
                    <a href={item.link} target="_blank" rel="noreferrer" style={{color:"blue", fontSize:"13px", textDecoration:"none"}}>🔗 Open Link</a>
                </div>
                <button onClick={() => handleDelete(item.id)} style={btnDelete}>🗑️</button>
            </div>
        ))}
      </div>
    </div>
  );
}

const inputStyle = { padding: "10px", borderRadius: "5px", border: "1px solid #ccc", flex: 1 };
const btnAdd = { backgroundColor: "#27ae60", color: "white", border: "none", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" };
const btnDelete = { backgroundColor: "#e74c3c", color: "white", border: "none", padding: "8px 12px", borderRadius: "5px", cursor: "pointer" };

export default Catalogs;